import { FunctionComponent } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { RouterOutletProps } from './RouterOutlet.props';
import { RouteProps, Route } from './components/route';

export const RouterOutlet: FunctionComponent<RouterOutletProps> = (props: RouterOutletProps) => {
  const { routes, basename } = props;

  return (
    <Switch>
      {routes.map((route: RouteProps, index: number) => {
        const { path, redirect } = route;

        return redirect ? (
          <Redirect key={index} path={path + ''} to={redirect} />
        ) : (
          <Route
            key={index}
            {...{
              ...route,
              path:
                basename && (basename !== '/' || basename !== process.env.PUBLIC_URL)
                  ? basename.replace(/\/$/, '') + path
                  : path,
            }}
          />
        );
      })}
    </Switch>
  );
};
